import { ContentTypeEnum } from 'constants-content';

type ContentWithUnpublishDate = {
  type?: ContentTypeEnum | string | null;
  unpublishDate?: Date | string | null;
};

// Static pages (waivers, forms) have no availability window, but legacy rows
// can carry a stale derived unpublishDate that must never block members.
export default function hasPassedUnpublishDate(
  content: ContentWithUnpublishDate | null | undefined
): boolean {
  if (!content?.unpublishDate || content.type === ContentTypeEnum.Static) {
    return false;
  }

  return new Date(content.unpublishDate) <= new Date();
}
